import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getPagePermissions,
    FIRST_CONFIG_APPLICATION
} from '../../security/permissions';

import './styles.css';
import {ConfigurationApp} from "../configurationApplication/components/ConfigurationApp";

class FirstConfigApplication extends Component {
    render() {
        return (
            <ConfigurationApp isCompanyRegistered={false}/>
        );
    }
}

const mapStateToProps = ({ userData, userData: { permissions } }) => ({
    userData,
    pagePermissions: getPagePermissions(FIRST_CONFIG_APPLICATION, permissions)
});
export default connect(mapStateToProps)(FirstConfigApplication);